import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const HEIGHT: number = gridSize * 6;
export const BANNER_NAME = 'MAIL_EXPIRY_REMINDER' as const;
